import ConsultingCompanyDetail from "./ConsultingCompanyDetail";
export default ConsultingCompanyDetail;
